import { LoadingCardDiv } from '../LoadingCardDiv';
import { FileCard } from '../FileCard';
import useGetLatestPolicy from '../../hooks/useGetLatestPolicy'
import useGetPopularPolicy from '../../hooks/useGetPopularPolicy';
import useGetRecommendSearch from '../../hooks/useGetRecommendSearch'
import { useLocation,useSearchParams,useNavigate} from 'react-router-dom';

import {useState, useEffect} from 'react'
export const HomeRecommends = (props) => {
    const {setFileName,setFileId,setMarkData,savedFoldListData,fileName,setMdTxt,getPdfAction,handleLoginRequired} = props
    const {latestPolicyLoading,latestPolicyData} = useGetLatestPolicy()
    const {popularPolicyLoading,popularPolicyData} = useGetPopularPolicy()

    const {recommendSearchLoading,recommendSearchData} = useGetRecommendSearch()
    const [tab,setTab] = useState('recommend')
    const navigate = useNavigate();

    const ContentDiv = (_loading, _data) => {
        return <>
            {
                _loading ? 
                <div className="w-full">
                    <div className="lg:mx-4 m-2 flex flex-col-reserve">
                        {[1,2,3,4,5].map((item,index) => (
                            <div className="card bg-base-100 border-b w-full">
                                <div className="card-body p-6 pb-4">
                                    <LoadingCardDiv/>
                                </div>                                                
                            </div>                                         
                        ))}
                    </div>
                </div>
                : 
                <>
                    {
                        _data && _data?.length > 0 ?
                        <div className="w-full">
                            <div className="lg:mx-4 m-2 flex flex-col-reserve">
                                {_data?.map((item,index) => 
                                    <div key={index}>
                                        <div className="card bg-base-100 border-b w-full">
                                            <div className="card-body p-6 pb-4">
                                                <FileCard
                                                    getPdfAction={getPdfAction}
                                                    fileName={fileName}
                                                    index={index}
                                                    item={item} 
                                                    setFileName={setFileName}
                                                    setFileId={setFileId}
                                                    setMarkData={setMarkData}
                                                    savedFoldListData={savedFoldListData}
                                                    mindmapVisible
                                                    setMdTxt={setMdTxt}
                                                    handleLoginRequired={handleLoginRequired}
                                                />
                                            </div>                                                
                                        </div>                                         
                                    </div>
                                )}
                            </div>
                        </div>
                         :
                        <div className="w-full py-8 text-center">
                            暂无内容
                        </div>
                    }
                </>
            }
        </>
    }
    return (
        <div className='flex-1 bg-base-200 py-4 pr-3 '>
            <div className="bg-base-100 p-6 shadow-lg">
                <div role="tablist" className="tabs tabs-lg tabs-bordered">
                <input 
                        type="radio" 
                        name="recommend" 
                        role="tab" 
                        className={`tab whitespace-nowrap font-[600] ${tab === 'recommend' ? 'text-primary' : '' } px-8`} 
                        aria-label="个性推荐" 
                        checked={tab==='recommend'}
                        onClick={()=>setTab('recommend')}
                    />
                    <div role="tabpanel" className="tab-content p-0 border-t">
                            {
                                tab==='recommend' &&
                                <>{ContentDiv(recommendSearchLoading,recommendSearchData)}</>
                            }
                    </div>

                    <input
                        type="radio"
                        name="latest"
                        role="tab"
                        className={`tab whitespace-nowrap font-[600] ${tab === 'latest' ? 'text-primary' : '' } px-8`}
                        aria-label="政策速递"
                        checked={tab==='latest'}
                        onClick={()=>setTab('latest')}
                    />
                    <div role="tabpanel" className="tab-content p-0">
                        {
                        tab==='latest' &&
                        <>
                        {ContentDiv(latestPolicyLoading,latestPolicyData)}
                        </>}
                        {/* <div className='flex justify-end mt-1'>
                            <button className='btn btn-link'
                                onClick={()=>navigate(`/policy/search?k=&org=`)}
                            >
                                查看更多 {'>>'} 
                            </button>
                        </div> */}
                    </div>

                   
                    
                    <input
                        type="radio"
                        name="polpular"
                        role="tab"
                        className={`tab whitespace-nowrap font-[600] ${tab === 'popular' ? 'text-primary' : '' } px-8`}
                        aria-label="热门政策"
                        checked={tab==='popular'}
                        onClick={()=>setTab('popular')}
                    />
                    <div role="tabpanel" className="tab-content p-0">
                        {
                            tab==='popular' &&
                            <>{ContentDiv(popularPolicyLoading,popularPolicyData)}</>
                        }
                    </div>



                </div>
            </div>
        </div>

    )
}